import { SHOPS, ShopId, ShopInfo } from '~/constants/shop';

const DEFAULT_VALUES: Pick<ShopInfo, 'sellerName' | 'shopNameKor' | 'shortDesc' | 'footerSellerText'> = {
  sellerName: '메루카리 개인 판매자',
  shopNameKor: '',
  shortDesc: '',
};

/** 등록된 상점이면 상점 정보를, 아니면 `undefined` 를 반환한다. 이미지 등 상점 전용 정보가 필요할 때 사용. */
export const findShop = (_shopId?: string): ShopInfo | undefined => SHOPS[_shopId as ShopId];

/** 텍스트 정보용. 등록되지 않은 상점이면 개인 판매자 기본값을 반환한다. */
export const getShopInfo = (_shopId?: string) => findShop(_shopId) ?? DEFAULT_VALUES;
export const getPaymentNotices = (_shopId?: ShopId) => {
  const sellerName = getShopInfo(_shopId).sellerName;
  return [
    `본 상품은 ${sellerName} 상품으로, 번개장터의 파트너사가 상품 구매와 배송을 대행해요.`,
    '파트너사가 상품 구매 절차를 진행한 이후에는 취소/환불이 제한될 수 있어요. (단, 판매자가 동의하면 취소/환불 가능해요.)',
    '통관 진행을 위해 수령인의 개인통관고유부호 입력이 필요해요.',
  ];
};
